import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/output.css';
import './styles/index.css';
import App from './components/App';
import DownloadRedirect from './components/DownloadRedirect';
import AppLinkFallback from './components/AppLinkFallback';
import NotFound from './components/NotFound';
import AdrenaliniumForm from './pages/adrenaliniumForm';
import AdrenaliniumSuccess from './pages/adrenaliniumSuccess';
import PrivacyPolicy from './pages/privacyPolicy';
import Terms from './pages/terms';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;

const MainComponent = (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/download" element={<DownloadRedirect />} />
      <Route path="/app/*" element={<AppLinkFallback />} />
      <Route path="/adrenalinium-2025" element={<AdrenaliniumForm />} />
      <Route path="/adrenalinium-2025/success" element={<AdrenaliniumSuccess />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/regulamin" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

// Use hydrateRoot if the page is prerendered, otherwise use createRoot
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      {MainComponent}
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      {MainComponent}
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 